import { Injectable, Pipe, PipeTransform } from '@angular/core';
@Injectable()
@Pipe({
    name: 'splitComma'
})
export class SplitCommaStringPipe implements PipeTransform {
    transform(val:string):string[] {
      return val.split(',');
    }
  }